/* eslint-disable indent */
//@flow
import { buildArticleModule, buildArticleModuleGroup } from '@finect/tabular-components/ArticleModuleBody';

const DEFAULT_TAG_REPLACE_TEXT = 'TAG-CONTENT';
const WIDGETS_TYPES = ['MODULE', 'GROUP'];
const WIDGETS_REGEX = new RegExp(`ARTICLE-(${WIDGETS_TYPES.join('|')})(?:[\\w-]*)?(?=\\s|<)`, 'g');

export const replacePtoH4 = (text: string) =>
  (text.startsWith('<h4>') ? text : `<h4>${text}</h4>`).replace(/<p>/g, '<h4>').replace(/<\/p>/g, '</h4>');

const buildTagContent = (tagContent: Object) => `
  <div class="tag-content" 
    data-tag="${tagContent.tag}" 
    data-title="${tagContent.title}" 
    data-text="${tagContent.text}" 
    data-text-cta="${tagContent.textCTA !== undefined ? tagContent.textCTA : 'Saber más'}" 
    data-link="${tagContent.link}" 
    data-link-rel="${tagContent.linkRel}" 
    data-color="${tagContent.color}" 
    data-color-cta="${tagContent.colorCTA || tagContent.color}"
    data-color-border="${tagContent.colorBorder || tagContent.color}"
  ></div>
`;

export const buildHTML = (html: string, tagContent: Object, modules: Array<Object>) => {
  let finalHTML = html;

  // Replace tag content
  if (tagContent?.active === 1) {
    if (finalHTML.includes(DEFAULT_TAG_REPLACE_TEXT)) {
      if (tagContent.content) finalHTML = finalHTML.replace(DEFAULT_TAG_REPLACE_TEXT, tagContent.content);
      if (tagContent.link) finalHTML = finalHTML.replace(DEFAULT_TAG_REPLACE_TEXT, buildTagContent(tagContent));
    } else {
      if (tagContent.content) finalHTML = `${finalHTML}${tagContent.content}`;
      if (tagContent.link) finalHTML = `${finalHTML}${buildTagContent(tagContent)}`;
    }
  }
  finalHTML = finalHTML.replace(DEFAULT_TAG_REPLACE_TEXT, '');

  // Find all article modules in the body
  const widgetsAliases = finalHTML.match(WIDGETS_REGEX) || [];

  // Replace widgets with their HTML
  widgetsAliases.forEach((widget) => {
    const matchingModule = modules.find(item => widget === `${item.type}-${item.alias}`);
    if (!matchingModule) return (finalHTML = finalHTML.replace(widget, ''));

    if (widget.includes('GROUP')) {
      if (!matchingModule.properties?.items?.length) return (finalHTML = finalHTML.replace(widget, ''));
      finalHTML = finalHTML.replace(widget, buildArticleModuleGroup(matchingModule));
    }

    if (!widget.includes('GROUP')) {
      finalHTML = finalHTML.replace(widget, buildArticleModule([matchingModule]));
    }
  });

  return finalHTML;
};
